import { useContext } from 'react';
import { IconOk, IconError } from '../img'
import { DataContext } from '../data/DataContext';


const Step7 = () => {

    const { ReclamosInspeccionNI } = useContext(DataContext);

    const cssStyle = {
        display: 'flex', justifyContent: 'center'
    }
    
    const finish = () => window.location.reload()

    return (
        <>
            <div style={cssStyle} className='mt-10'>
                {ReclamosInspeccionNI.saved && <IconOk width={50} />}
                {!ReclamosInspeccionNI.saved && <IconError width={50} />}
            </div>
            <div style={{ ...cssStyle, color: '#018765', fontWeight: '600', fontSize: '23px' }} className='mt-20'>
                {ReclamosInspeccionNI.saved && <span>¡Todo listo!</span>}
                {!ReclamosInspeccionNI.saved && <span>¡Oops!</span>}
            </div>
            <div style={{ ...cssStyle, textAlign: 'center', color: '#4D4D4D', fontWeight: '600', fontSize: '15px' }}>
                {ReclamosInspeccionNI.saved && <span>Se generó el número de trámite <br></br>  {ReclamosInspeccionNI.numberProcedure}</span>}
                {!ReclamosInspeccionNI.saved && <span>Ocurrió un problema</span>}
            </div>
            {ReclamosInspeccionNI.saved && <div style={{ ...cssStyle, color: '#4D4D4D', fontSize: '14px', textAlign:'justify' }} className='mt-30' >
                <span>Enviaremos al correo electrónico del asegurado los documentos necesarios para completar tu expediente de reclamos.</span>
            </div>
            }
            {ReclamosInspeccionNI.saved && <div style={{ ...cssStyle, color: '#4D4D4D', fontSize: '14px', textAlign:'justify' }} className='mt-10'>
                <span>¿El cliente necesita ayuda? Indicar que puede continuar su trámite de reclamo a través de nuestro portal “Consulta y/o completa tu trámite”. También puede contactarnos a través de nuestro Whatsapp 8794-4040 o bien llamar a nuestro Call Center al 2255-8484.</span>
            </div>
            }

            {!ReclamosInspeccionNI.saved && <div style={{ ...cssStyle, textAlign:'center', color: '#4D4D4D', fontSize: '14px' }} className='mt-10'>
                <span>Revisaremos la información ingresada y de ser necesario, nuestros ejecutivos se contactarán contigo para confirmar datos y continuar el proceso de tu reclamo.</span>
            </div>
            }

            <div style={cssStyle} className='mt-30 '>
                <button className='btn-re-ni next' onClick={finish}>Finalizar</button>
            </div>
        </>
    )
}
export { Step7 }